import { HugeiconsIcon } from '@hugeicons/react';
import { ArrowRight01Icon } from '@hugeicons/core-free-icons';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { log } from '@/lib/logger';

interface StepWelcomeProps {
  companyName: string;
  onChange: (name: string) => void;
  onNext: () => void;
}

export function StepWelcome({ companyName, onChange, onNext }: StepWelcomeProps) {
  log.info('[StepWelcome] render', { companyName });

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="hero-title">Let's set up your first review</h2>
        <p className="mt-2 text-gray-500">
          Set up your first project.
        </p>
      </div>

      <div className="space-y-2">
        <label
          htmlFor="onboarding-company-name"
          className="field-label"
        >
          What's your company name? <span className="text-gray-400 font-normal">(optional)</span>
        </label>
        <Input
          id="onboarding-company-name"
          type="text"
          value={companyName}
          onChange={(e) => {
            log.info('[StepWelcome] company name changed', { value: e.target.value });
            onChange(e.target.value);
          }}
          placeholder="Acme Inc."
          maxLength={200}
          autoFocus
        />
      </div>

      <Button
        variant="primary"
        size="md"
        className="w-full"
        onClick={() => {
          log.info('[StepWelcome] continue clicked');
          onNext();
        }}
      >
        <span className="flex items-center justify-center gap-2">
          Continue
          <HugeiconsIcon icon={ArrowRight01Icon} size={16} strokeWidth={2} color="currentColor" className="h-4 w-4" />
        </span>
      </Button>
    </div>
  );
}
